import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { THYROID } from "../../../../constants";


export default function ThyroidAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={THYROID}
        title="THYROID HEALTH"
        subtitle="Complete thyroid assessment for metabolism, energy, and reproductive health in both women and men"
        markersTitle=" 79,- incl. VAT"
        markers="Thyroid-Stimulating Hormone (TSH), free T3, free T4, Calcitonin"
    />


)
}